import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get projects by organization for me
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetMyProjects = packet => {
  return {
    type: 'REQUEST_GET_MY_PROJECTS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetMyProjectsSuccess = data => ({
  type: 'RECEIVE_GET_MY_PROJECTS_SUCCESS',
  data
})

export const receiveGetMyProjectsFail = data => ({
  type: 'RECEIVE_GET_MY_PROJECTS_FAIL',
  data
})

export const tryToGetMyProjects = packet => (dispatch, getState) => {

  dispatch(requestGetMyProjects(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/projects/org/' + packet.org_id + '/mine', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetMyProjectsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetMyProjectsFail({errors:e, lastSubmit: packet}));
    })
}
